<template>
  <div style="padding: 20px">
    <div style="background-color: #FFFFFF;border-radius: 8px;padding: 24px;max-height: 1160px;overflow-y: auto">
      <div style="display: flex;justify-content: space-between">
        <div>
          <el-input v-model="query.name" placeholder="请输入名称" style="width: 300px" />
          <el-button type="primary" style="margin-left: 15px" @click="getList">搜索</el-button>
        </div>
        <div>
          <el-button type="success" @click="add">添加</el-button>
        </div>
      </div>
      <div style="border: 1px solid #e6ebf2;border-radius: 6px;margin-top: 20px;border-bottom: none">
        <el-table
          :data="table_data.list"
          :header-cell-style="{ backgroundColor: '#f5f7fa' }"
          style="border-radius: 6px"
        >
          <el-table-column prop="id" label="ID">
            <template #header>
              <div style="padding-left: 24px;">ID</div>
            </template>
            <template #default="scope">
              <div style="padding-left: 24px;">{{ scope.row.id }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" />
          <el-table-column prop="description" label="描述" />
          <el-table-column label="年龄">
            <template slot-scope="scope">
              <el-tag
                v-for="(label, index) in mapAgeCodesToLabels(scope.row.age)"
                :key="index"
                type="success"
                style="margin-right: 6px"
              >
                {{ label }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="hide_if_converted" label="过滤类型">
            <template slot-scope="scope">
              {{ getLabelFromOptions(hide_if_converted_options, scope.row.hide_if_converted) }}
            </template>
          </el-table-column>
          <el-table-column prop="hide_if_converted" label="性别">
            <template slot-scope="scope">
              {{ getLabelFromOptions(gender_options, scope.row.gender) }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="action-btn" style="color: #165DFF" @click="edit(scope.row)">修改</span>
              <span class="action-btn" style="color: #F53F3F" @click="del(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination-right
        :total="table_data.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
    <el-dialog
      :visible.sync="visible"
      :title="id? '编辑定向包':'新增定向包'"
    >
      <el-form
        ref="formRef"
        label-width="120px"
        :model="form_data"
        :rules="formRules"
      >
        <el-form-item label="定向包名称">
          <el-input v-model="form_data.name" style="width: 300px" />
        </el-form-item>
        <el-form-item label="地域">
          <el-radio-group v-model="form_data.district">
            <el-radio-button
              v-for="item in district_options"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form_data.district === 'REGION'">
          <el-button type="primary" @click="regionDist">选择区域</el-button>
          <div style="width: 700px;max-height: 300px;overflow-y: auto">
            <el-tag v-for="(item, index) in tree_selected" :key="index" style="margin: 5px">
              {{ item.label }}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="form_data.gender">
            <el-radio-button
              v-for="item in gender_options"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄">
          <el-checkbox-group v-model="form_data.age">
            <el-checkbox-button
              v-for="option in age_options"
              :key="option.value"
              :label="option.value"
            >
              {{ option.label }}
            </el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="平台">
          <el-radio-group v-model="form_data.platform">
            <el-radio-button :label="null">不限</el-radio-button>
            <el-radio-button label="ANDROID">Android</el-radio-button>
            <el-radio-button label="IOS">IOS</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="过滤已转化用户">
          <el-radio-group v-model="form_data.hide_if_converted">
            <el-radio-button
              v-for="item in hide_if_converted_options"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="定向包描述">
          <el-input v-model="form_data.description" type="textarea" :rows="2" placeholder="请输入内容" style="width: 300px" />
        </el-form-item>
        <el-form-item style="text-align: center;">
          <el-button type="primary" @click="commit">提交</el-button>
          <el-button type="info" @click="visible = false">取消</el-button>
        </el-form-item>
      </el-form>
      <el-dialog
        :visible.sync="tree_visible"
        title="选择区域"
        append-to-body
      >
        <el-tree
          ref="regionTree"
          :data="tree_data"
          node-key="value"
          show-checkbox
          :default-checked-keys="selectedCodes"
        />
        <el-button type="success" @click="commitTree">确定</el-button>
        <el-button type="info" @click="tree_visible = false">取消</el-button>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>

import { cityList, packageCreate, packageDel, packageList, packageUpd } from '@/api/customer'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      hide_if_converted_options: [
        { label: '不限制', value: 'NO_EXCLUDE' },
        { label: '广告', value: 'PROMOTION' },
        { label: '推广项目', value: 'PROJECT' },
        { label: '广告账户', value: 'ADVERTISER' },
        { label: '公司账户', value: 'CUSTOMER' },
        { label: '组织账户', value: 'ORGANIZATION' }
      ],
      gender_options: [
        { label: '不限', value: 'NONE' },
        { label: '男', value: 'GENDER_MALE' },
        { label: '女', value: 'GENDER_FEMALE' }
      ],
      district_options: [
        { label: '不限', value: 'NONE' },
        { label: '行政区域', value: 'REGION' }
      ],
      age_options: [
        { label: '20岁以下', value: 'AGE_BELOW_20' },
        { label: '20-23', value: 'AGE_BETWEEN_20_23' },
        { label: '24-27', value: 'AGE_BETWEEN_24_27' },
        { label: '28-35', value: 'AGE_BETWEEN_28_35' },
        { label: '36-45', value: 'AGE_BETWEEN_36_45' },
        { label: '46-55', value: 'AGE_BETWEEN_46_55' },
        { label: '56-59', value: 'AGE_BETWEEN_56_59' },
        { label: '60岁以上', value: 'AGE_ABOVE_60' }
      ],
      query: {
        page: 1,
        page_size: 10
      },
      table_data: {
        list: [],
        total: 0
      },
      visible: false,
      form_data: {
        name: null,
        description: null,
        district: 'NONE',
        city: [],
        gender: 'NONE',
        age: [],
        platform: 'ANDROID',
        hide_if_converted: 'NO_EXCLUDE'
      },
      mapping: {
        AGE_BETWEEN_20_23: '20-23',
        AGE_BETWEEN_24_27: '24-27',
        AGE_BETWEEN_28_35: '28-35',
        AGE_BETWEEN_36_45: '36-45',
        AGE_BETWEEN_46_55: '46-55',
        AGE_BETWEEN_56_59: '56-59',
        AGE_ABOVE_60: '60岁以上',
        AGE_BELOW_20: '20岁以下'
      },
      formRules: {
        name: [
          { required: true, message: '请输入定向包名称', trigger: 'blur' }
        ],
        district: [
          { required: true, message: '请选择地域', trigger: 'change' }
        ],
        gender: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        age: [
          { required: true, type: 'array', min: 1, message: '请选择年龄段', trigger: 'change' }
        ],
        hide_if_converted: [
          { required: true, message: '请选择过滤类型', trigger: 'change' }
        ],
        description: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ]
      },
      tree_data: [],
      id: null,
      tree_visible: false,
      selectedCodes: [],
      tree_selected: []
    }
  },
  created() {
    this.getList()
    this.cityList()
  },
  methods: {
    getList() {
      packageList(this.query).then(res => {
        console.log(res)
        this.table_data = res.data.data
      })
    },
    cityList() {
      cityList().then(res => {
        console.log(res)
        this.tree_data = this.transformToTree(res.data.districts[0].sub_districts)
        console.log(this.tree_data)
      })
    },
    del(val) {
      console.log(val)
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        packageDel({ id: val.id }).then(res => {
          if (res.code === 0) {
            this.$message.success('删除成功')
            this.getList()
          }
        })
      })
    },
    edit(val) {
      console.log(val)
      this.id = val.id
      this.form_data = val
      this.form_data.age = JSON.parse(val.age)
      const cityJson = JSON.parse(val.city)
      console.log(cityJson)
      this.form_data.city = cityJson
      this.selectedCodes = cityJson
      this.visible = true
    },
    add() {
      this.form_data = {
        name: null,
        description: null,
        district: 'NONE',
        city: [],
        gender: 'NONE',
        age: [],
        platform: null,
        hide_if_converted: 'NO_EXCLUDE'
      }
      this.visible = true
    },
    mapAgeCodesToLabels(ageArray) {
      if (!Array.isArray(ageArray)) {
        try {
          ageArray = JSON.parse(ageArray || '[]')
        } catch (e) {
          return []
        }
      }
      return ageArray.map(code => {
        const found = this.age_options.find(opt => opt.value === code)
        return found ? found.label : code
      })
    },
    getLabelFromOptions(options, value) {
      const match = options.find(item => item.value === value)
      return match ? match.label : value
    },
    commit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 通过验证，提交逻辑写这里
          console.log('提交表单', this.form_data)
          if (this.id) {
            const payload = {
              ...this.form_data,
              id: this.id
            }
            packageUpd(payload).then(res => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('修改成功')
                this.visible = false
                this.getList()
              }
            })
          } else {
            packageCreate(this.form_data).then(res => {
              console.log(res)
              if (res.code === 0) {
                this.$message.success('新增成功')
                this.getList()
                this.visible = false
              }
            })
          }
        } else {
          return this.$message.error('表单校验失败,请输入正确的值')
        }
      })
    },
    transformToTree(list) {
      return list.map(item => {
        const node = {
          label: item.name,
          value: item.code, // 你需要用这个 ID
          level: item.level,
          geoname_id: item.geoname_id
        }

        if (item.sub_districts && item.sub_districts.length > 0) {
          node.children = this.transformToTree(item.sub_districts)
        }

        return node
      })
    },
    regionDist() {
      this.tree_visible = true
    },
    getMinimalCheckedKeys() {
      const tree = this.$refs.regionTree
      const result = []

      function isAllChildrenChecked(node) {
        if (!node.children || node.children.length === 0) return false
        return node.children.every(child => {
          const childNode = tree.getNode(child)
          return childNode && childNode.checked
        })
      }

      function walk(nodes) {
        for (const node of nodes) {
          const currentNode = tree.getNode(node)

          if (!currentNode) continue

          if (isAllChildrenChecked(node)) {
            // 子全选，保留父节点
            result.push({
              value: node.value,
              label: node.label,
              level: node.level,
              geoname_id: node.geoname_id
            })
          } else if (currentNode.checked && (!node.children || node.children.length === 0)) {
            // 叶子节点选中
            result.push({
              value: node.value,
              label: node.label,
              level: node.level,
              geoname_id: node.geoname_id
            })
          } else if (node.children) {
            // 半选 → 继续递归子节点
            walk(node.children)
          }
        }
      }

      const rootNodes = tree.root.data // 原始数据
      walk(rootNodes)

      return result
    },
    commitTree() {
      const keys = this.getMinimalCheckedKeys()
      console.log('选择结果:', keys)
      this.form_data.city = keys.map(item => item.value)
      this.tree_selected = keys
      this.tree_visible = false
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.getList()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.getList()
    }
  }
}
</script>

<style scoped>
.action-btn {
  cursor: pointer;
  color: #409EFF;
  margin: 0 10px;
  transition: color .2s;
}
.action-btn:hover {
  opacity: .8;
}
</style>
